// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__DXnpm","sendOtp":"AuthorizeToLogin_sendOtp__2NqNb"};